import { Card } from '@mui/material';
import { Column, Row } from 'Components/Grid';
import { ContainerIcon } from '../styles';
import { ReactComponent as CopyIcon } from './../../../../assets/copy_icon.svg';

export const CardCopyCode = ({ setShowCopyCode, setShowGtm, showCopyCode }) => {
  return (
    <Card
      sx={{
        padding: '16px',
        marginBlockStart: '16px',
        backgroundColor: '#fffeFe',
        boxShadow: 'none',
        border: '1px solid #ccc',
      }}
    >
      <Row className="mb-3">
        <Column xs={9} style={{ fontSize: '20px', fontWeight: '500' }}>
          Copiar código
        </Column>
        <Column style={{ display: 'flex', justifyContent: 'end' }}>
          <ContainerIcon
            onClick={() => {
              setShowGtm(false);
              setShowCopyCode(!showCopyCode);
            }}
            active={showCopyCode}
          >
            <CopyIcon width="44px" height="44px" style={{ padding: '8px' }} />
          </ContainerIcon>
        </Column>
      </Row>
      <Row className="mb-3">
        <Column xs={12}>
          <p className="mt-0 mb-4">
            Você só tem que colar o código no inicio da tag {'<HEAD/>'}
            do conteúdo HTML do seu site.
          </p>
        </Column>
      </Row>
    </Card>
  );
};
